import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CaFormFieldComponent, CaHint, CaIcon, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';

@Component({
	selector: 'app-buscar-version-matricula',
	standalone: true,
	imports: [
		CommonModule,
		CaFormFieldComponent,
		CaLabel,
		CaInputDirective,
		CaIcon,
		CaButtonComponent,
		CaHint,	
		ReactiveFormsModule,	
		TranslateModule
	],
	templateUrl: './buscar-version-matricula.component.html',
	styleUrls: ['./buscar-version-matricula.component.scss']
})
export class BuscarVersionMatriculaComponent implements OnInit, OnDestroy{
	public buscarMatriculaForm: FormGroup;

	constructor(
			private formBuilder: FormBuilder, 
			private autosStore: AutosBusquedaStoreService,
	) { }

	ngOnDestroy(): void {
		this.buscarMatriculaForm?.reset(); 
	}

	ngOnInit(): void {
		this.buscarMatriculaForm = this.formBuilder.group({matricula: ['',[Validators.required]]});
	}

	buscarMatricula() {
		if (this.buscarMatriculaForm.invalid) {
			return;
		}
		this.autosStore.getVersionesPorMatricula(this.buscarMatriculaForm.value?.matricula);
	}
}
